import { defineStore } from 'pinia';

import { BiomarkerManager } from './analysis/biomarker-manager-class';

export const useAnalysisStore = defineStore('analysis', {
  state: () => ({
    biomarkerData: null as BiomarkerManager | null,
    syncAnalysisBiomarkers: false,
  }),

  getters: {
    isBiomarkerSyncEnabled: state => state.syncAnalysisBiomarkers,
  },
  actions: {
    setBiomarkerSyncEnabled(enabled: boolean) {
      this.syncAnalysisBiomarkers = enabled;
    },
    toggleBiomarkerSync() {
      this.syncAnalysisBiomarkers = !this.syncAnalysisBiomarkers;
      return this.syncAnalysisBiomarkers;
    },
    initBiomarkerContainer() {
      this.biomarkerData = new BiomarkerManager();
      return this.biomarkerData;
    },
    getBiomarkerContainer() {
      if (!this.biomarkerData) {
        this.biomarkerData = new BiomarkerManager();
      }
      return this.biomarkerData;
    },

    isStudyComplete(): boolean {
      if (!this.biomarkerData) return false;
      return this.biomarkerData.isStudyComplete();
    },

    resetStudy() {
      this.syncAnalysisBiomarkers = false;
      return this.initBiomarkerContainer();
    },
  },
});
